import { useI18n } from "@/providers/i18n-provider";
import { useAccounts } from "@/features/auth/use-accounts";
import { readTabAccountId } from "@/lib/tab-account";
import { Button } from "@/components/ui/button";
import { msg } from "@lingui/core/macro";
import { For, Show } from "solid-js";

export function TryAnotherAccount() {
  const { t } = useI18n();
  const { accounts, switchHere } = useAccounts();
  const activeId = () => readTabAccountId();

  const otherAccounts = () => accounts().filter((acc) => acc.userId !== activeId());

  return (
    <Show when={otherAccounts().length > 0}>
      <div class="mt-4 flex flex-col items-center gap-2 rounded-lg border border-border/40 bg-muted/20 p-3">
        <p class="text-xs text-muted-foreground">
          {t(msg`Signed in with more than one account? Try another one:`)}
        </p>
        <div class="flex flex-wrap justify-center gap-2">
          <For each={otherAccounts()}>
            {(acc) => (
              <Button
                variant="outline"
                size="sm"
                onClick={() => {
                  void switchHere(acc.userId);
                }}
              >
                {acc.displayName || acc.email}
              </Button>
            )}
          </For>
        </div>
      </div>
    </Show>
  );
}
